import { render, staticRenderFns } from "./request-send-access-link.vue?vue&type=template&id=2af31ce7"
import script from "./request-send-access-link.vue?vue&type=script&lang=js"
export * from "./request-send-access-link.vue?vue&type=script&lang=js"
import style0 from "./request-send-access-link.vue?vue&type=style&index=0&id=2af31ce7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports